import { Routes } from '@angular/router';
import { ANNOUNCEMENT_ROLES, CUSTOMER_USER_ROLES } from './core/roles';
import { authGuard } from './auth.guard';
import { roleGuard } from './role-guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/homepage/home.component').then(module => module.TaasHomeComponent),
    canActivate: [authGuard]
  },
  {
    path: 'announcements',
    loadComponent: () => import('./features/announcements/announcements.component')
      .then(module => module.AnnouncementsComponent),
    canActivate: [authGuard, roleGuard(ANNOUNCEMENT_ROLES, '')]
  },
  {
    path: 'customer-support/customer-users',
    loadComponent: () => import('./features/customer-users/customer-users.component')
      .then(module => module.CustomerUsersComponent),
    canActivate: [authGuard, roleGuard(CUSTOMER_USER_ROLES, '')]
  }
];
